const nl = {
  // Nav
  nav_home: 'Home',
  nav_products: 'Producten',
  nav_about: 'Over Ons',
  nav_contact: 'Contact',
  nav_explore: 'Ontdekken',

  // Hero
  hero_badge: 'Krabpalen · Professionele Kwaliteit',
  hero_title1: 'Leven met Katten',
  hero_title2: 'Elke Krabbeweging',
  hero_title3: 'Is een Vreugdevol Ritueel',
  hero_desc: 'Premium natuurlijke materialen gecombineerd met ergonomisch ontwerp — katten helpen van hun krabpalen te houden en uw huis mooier te maken. Koorpet, beschermt het geluk achter elke pootafdruk.',
  hero_btn_products: 'Producten Ontdekken',
  hero_btn_about: 'Ons Verhaal',
  hero_stat1_num: '6+',
  hero_stat1_label: 'Jaar in de Branche',
  hero_stat2_num: '50+',
  hero_stat2_label: 'Productlijnen',
  hero_stat3_num: '100K+',
  hero_stat3_label: 'Katten Vertrouwen Ons',
  hero_scroll: 'Scroll Omlaag',

  // Featured Products
  featured_label: 'Uitgelichte Producten',
  featured_title: 'Bestsellers',
  featured_subtitle: 'De Favoriete Collectie van Katten',
  featured_view_all: 'Alle Producten Bekijken',
  featured_empty: 'Nog geen uitgelichte producten',

  // Features Section
  features_badge: 'Kernvoordelen',
  features_title: 'Waarom Koorpet Kiezen',
  features_desc: 'Elk product ondergaat rigoureuze R&D-tests om katten de beste krabervaring te bieden',
  feature1_title: 'Drielaags Hoge Dichtheid',
  feature1_desc: 'Premium golfkarton met drielaagse heetperstechnologie, 2x dichter dan gewone producten, duurzamer en langer meegaand.',
  feature2_title: 'Natuurlijke Kattenkruid Infusie',
  feature2_desc: 'Biologisch kattenkruid gelijkmatig geïnfuseerd tussen kartonlagen, geeft langdurig natuurlijke geur af die katten aantrekt.',
  feature3_title: 'Niet-Giftig Eco Gecertificeerd',
  feature3_desc: 'Alle materialen slagen voor nationale milieutoetsing — vrij van formaldehyde en zware metalen, veilig zelfs als katten erop kauwen.',
  feature4_title: 'Ergonomisch Ontwerp',
  feature4_desc: 'Gebaseerd op onderzoek naar krabgedrag van katten, geoptimaliseerde hoeken en hoogtes die perfect passen bij de natuurlijke krabhouding van katten.',

  // Brand Section
  brand_label: 'Toegewijd Vakmanschap',
  brand_title1: 'Toegewijd Vakmanschap',
  brand_title2: 'Voor Één Perfecte Krabpaal',
  brand_desc: 'Koorpet werd opgericht in 2024 en is een toonaangevend merk gewijd aan R&D en productie van krabpalen in China. Onze fabriek beslaat 4.000 vierkante meter met volledig geautomatiseerde productielijnen en een jaarlijkse capaciteit van 2 miljoen eenheden. Wij geloven dat een goede krabpaal niet alleen meubels beschermt, maar ook de levenskwaliteit van katten verbetert. Elk proces, van grondstofselectie tot eindproduct, ondergaat strenge kwaliteitscontrole.',
  brand_years_num: '2024',
  brand_years_label: 'Opgericht In',
  brand_years_desc: 'Met een moderne fabriek van 4.000 vierkante meter en volledig geautomatiseerde productielijnen, voortdurend hoogwaardige krabpalen leverend voor kattenfamilies wereldwijd.',
  brand_cert1_label: 'Nationale Kwaliteitscert.',
  brand_cert1_sub: 'ISO 9001 Gecertificeerd',
  brand_cert2_label: 'Natuurlijke Eco Materialen',
  brand_cert2_sub: 'Niet-Giftig Gecertificeerd',
  brand_cert3_label: 'Export naar 10+ Landen',
  brand_cert3_sub: 'Internationale Normen',
  brand_cert4_label: '100K+ Katten',
  brand_cert4_sub: 'Vertrouwde Keuze',
  brand_cta: '',

  // CTA Section
  cta_quote_label: 'Stem van Katteneigenaar',
  cta_quote: '"Dankzij Koorpet is mijn bank eindelijk veilig!"',
  cta_label: 'Onderneem Actie',
  cta_title1: 'Laat Uw Kat Houden van',
  cta_title2: 'Hun Eigen Territorium',
  cta_desc: 'Meer dan 100 duizend katten hebben Koorpet gekozen. Natuurlijke materialen, doordacht ontwerp, strenge kwaliteitscontrole — elk product is het beste cadeau voor uw kat. Bestel nu en geniet van kwaliteitsleven.',
  cta_btn: 'Nu Winkelen',

  // Reviews Section
  reviews_title: 'Echte Katteneigenaar Reviews:',
  reviews_subtitle: 'Echte beoordelingen van katteneigenaren door het hele land',
  review1_name: 'Oranje Kattenmama',
  review1_content: 'Ik heb de Cloud Serie gekocht en mijn oranje kat was er meteen verliefd op! Geweldige kwaliteit, stevig karton, de kattenkruidgeur trekt hem enorm aan. Echt een aanrader!',
  review1_product: 'Cloud Serie Krabpaal',
  review2_name: 'Ragdoll Eigenaar',
  review2_content: 'De Sisal Krabpaal is fijn afgewerkt, het sisaltouw is strak gewikkeld, de basis is zeer stabiel. Mijn ragdoll krabt er elke dag aan, de bank is eindelijk veilig!',
  review2_product: 'Sisal Krabpaal',
  review3_name: 'Lapjeskat Baasje',
  review3_content: 'De Golfkrabplank heeft een slim ontwerp, omkeerbaar voor dubbele levensduur, geweldige prijs-kwaliteitverhouding. Mijn kat ligt er graag op te slapen, twee vliegen in één klap!',
  review3_product: 'Golfkarton Krabplank',
  review4_name: 'Britse Korthaar Papa',
  review4_content: 'Verpakking is erg zorgvuldig, productkwaliteit is onberispelijk. Klantenservice reageert ook snel, direct antwoord. Ik heb al drie keer opnieuw besteld, het is het favoriete merk van mijn kat!',
  review4_product: 'Kattenkruid Ronde Krabpaal',

  // About Banner
  about_breadcrumb_home: 'Home',
  about_breadcrumb_about: 'Over Ons',
  about_banner_title: 'Over Koorpet',
  about_banner_desc: 'Vakmanschap en kwaliteit, gewijd aan het geluk van elke kat. Wij geloven dat geweldige producten de band tussen mensen en huisdieren nog mooier maken.',

  // Company Stats
  stat1_num: '2024',
  stat1_label: 'Opgericht',
  stat1_sub: 'Diep in de huisdierenbranche',
  stat2_num: '50+',
  stat2_label: 'Producten',
  stat2_sub: 'Alle kattenscenario\'s gedekt',
  stat3_num: '100K+',
  stat3_label: 'Katten',
  stat3_sub: 'Vertrouwen Koorpet',
  stat4_num: '30+',
  stat4_label: 'Patenten',
  stat4_sub: 'Continue innovatie',

  // Brand Story
  story_label: 'Ons Verhaal',
  story_float_num: '2024',
  story_float_desc: 'Diep in krabpaalveld, gericht op kwaliteit en innovatie',
  story_title1: 'Van Één Krabpaal',
  story_title2: 'naar de Geboorte van een Merk',
  story_p1: 'Opgericht in 2024 is Koorpet een toonaangevend merk gewijd aan R&D en productie van krabpalen in China. Wij beschikken over een moderne fabriek van 4.000 vierkante meter met volledig geautomatiseerde productielijnen en een jaarlijkse capaciteit van 2 miljoen eenheden.',
  story_p2: 'Met jarenlange ervaring in de huisdierenbranche herkende onze oprichter het gebrek aan producten op de markt die echt streven naar kwaliteit en gebruikerservaring. Vastbesloten om Koorpet te creëren, herdefinieerde hij de krabpaal met hogere normen.',
  story_p3: 'Van grondstofselectie tot eindproduct, elk proces ondergaat strenge kwaliteitscontrole. Wij houden vast aan de filosofie van "natuurlijke materialen, doordacht ontwerp, strenge kwaliteitscontrole", toegewijd aan het bieden van de beste krabervaring voor elke kat. Vandaag is Koorpet een vertrouwd krabpaalmerk, met producten verkocht in veel landen en regio\'s.',
  story_founder_name: 'John Yu',
  story_founder_role: 'Oprichter van Koorpet',
  story_founder_quote: '"We maken niet alleen krabpalen — we creëren een betere leefruimte voor elke kattenfamilie."',

  // Timeline
  timeline_label: 'Mijlpalen',
  timeline_title: 'Onze Reis',
  timeline_desc: 'Van OEM-productie naar eigen merk, elke stap is stabiel. Dit zijn de voetafdrukken van Koorpet\'s groei.',
  milestone1_title: 'OEM Bedrijfslancering',
  milestone1_desc: 'Begon met OEM-krabpaalproductie voor internationale huisdierenmerken, bouwde supply chain foundations en productie-expertise en kwaliteitscontrole-ervaring op.',
  milestone2_title: 'Fabriek Uitbreiding',
  milestone2_desc: 'Breidde een modern 4.000 vierkante meter fabriek uit, introduceerde volledig geautomatiseerde productielijnen, met een jaarlijkse capaciteit van 5 miljoen eenheden.',
  milestone3_title: 'Export Doorbraak',
  milestone3_desc: 'OEM-producten geëxporteerd naar 10+ landen en regio\'s, meer dan 50 overzeese klanten bediend, met kwaliteit internationaal erkend.',
  milestone4_title: 'Merk Voorbereiding',
  milestone4_desc: 'Een onafhankelijk R&D-team samengesteld, het eigen merk Koorpet voorbereid, de eerste batch originele productontwerpen en patentlay-out voltooid.',
  milestone5_title: 'Koorpet Opgericht',
  milestone5_desc: 'Het merk Koorpet werd officieel opgericht, de eerste hoge-dichtheid golfkarton krabpaal serie gelanceerd met grote marktreceptie.',
  milestone6_title: 'Productlijn Uitbreiding',
  milestone6_desc: 'Lanceerde sisal krabpalen, kattenboom serie en andere nieuwe producten, slaagde voor ISO 9001 en andere internationale certificeringen, merkinvloed bleef groeien.',
  milestone7_title: 'Gebruikers Mijlpaal',
  milestone7_desc: 'Meer dan 100 duizend kattenfamilies bediend, Koorpet is een toonaangevend krabpaalmerk in China geworden, blijft de industrie leiden.',

  // Team Section
  team_label: 'Ons Team',
  team_title: 'Kernteam',
  team_desc: 'Een groep echte kattenliefhebbers, elk product met expertise en passie vervaardigend',
  team_more: 'Plus',
  team_more2: 'gepassioneerde Koorpet professionele teamleden achter de schermen',
  team1_name: 'John Yu',
  team1_role: 'Oprichter',
  team1_desc: 'Eerder kanaaldirecteur bij een toonaangevend industrieel bedrijf, met diepgaand inzicht in de huisdierenproductenmarkt. Gebaseerd op een diep begrip van kattenwelzijn en een onwrikbaar streven naar productkwaliteit, richtte Koorpet op in 2024, leidde het team van OEM-productie naar eigen merk, en realiseerde een doorbraak van nul naar één.',
  team1_tag1: 'Merkoprichting',
  team1_tag2: 'Kanaaluitbreiding',
  team2_name: 'Lin Xiaowen',
  team2_role: 'Hoofdontwerper',
  team2_desc: 'Afgestudeerd aan de Centrale Academie voor Schone Kunsten in Industrieel Ontwerp, 8 jaar in huisdierenproductontwerp, leidde het uiterlijkontwerp van 30+ Koorpet-producten.',
  team2_tag1: 'Productontwerp',
  team2_tag2: 'Gebruikerservaring',
  team3_name: 'Wang Jianguo',
  team3_role: 'O&O Directeur',
  team3_desc: 'PhD in Materiaalkunde, 10 jaar gericht op R&D van huisdierenproductmaterialen, leidde de ontwikkeling van Koorpet\'s laag-stof formule en kattenkruid infusieproces.',
  team3_tag1: 'Materialen O&O',
  team3_tag2: 'Procesinnovatie',
  team4_name: 'Zhang Meiling',
  team4_role: 'Kwaliteitsdirecteur',
  team4_desc: 'Houdt ISO kwaliteitsmanagementsysteemcertificering, verantwoordelijk voor kwaliteitscontrole over alle Koorpet-productlijnen, zorgt ervoor dat elk product aan fabrieksnormen voldoet.',
  team4_tag1: 'Kwaliteitscontrole',
  team4_tag2: 'ISO Gecertificeerd',

  // Certificates
  cert_label: 'Certificeringen',
  cert_title: 'Referenties & Certificeringen',
  cert_desc: 'Meerdere gezaghebbende certificeringen — het beste bewijs van Koorpet\'s kwaliteit en innovatie',
  cert1_title: 'ISO 9001',
  cert1_sub: 'Kwaliteitsmanagementsysteem',
  cert1_desc: 'Slaagde voor internationale kwaliteitsmanagementsysteemcertificering, volledig traceerbaar productieproces, kwaliteit gegarandeerd.',
  cert1_year: 'Verkregen in 2018',
  cert2_title: 'Eco Niet-Giftig Cert.',
  cert2_sub: 'Nationale Eco-test Geslaagd',
  cert2_desc: 'Alle materialen slagen voor nationale milieutoetsing — vrij van formaldehyde en zware metalen, veilig zelfs als katten erop kauwen.',
  cert2_year: 'Verkregen in 2017',
  cert3_title: 'Huisdierenproduct Veiligheidscert.',
  cert3_sub: 'China Huisdierenproducten Associatie',
  cert3_desc: 'Veiligheidscertificering toegekend door de China Huisdierenproducten Associatie, een van de weinige merken in de branche die deze certificering heeft ontvangen.',
  cert3_year: 'Verkregen in 2019',
  cert4_title: 'CE Europese Cert.',
  cert4_sub: 'EU Markttoegang',
  cert4_desc: 'Slaagde voor EU CE-certificering, producten voldoen aan EU-veiligheids-, gezondheids- en milieunormen, geschikt voor verkoop op de EU-markt.',
  cert4_year: 'Verkregen in 2020',

  // About CTA
  about_cta_label: 'Doe Mee',
  about_cta_title1: 'Samen, Laten We Creëren',
  about_cta_title2: 'Een Beter Leven voor Katten',
  about_cta_btn1: 'Producten Ontdekken',
  about_cta_btn2: 'Neem Contact Op',

  // Products Banner
  products_breadcrumb_home: 'Home',
  products_breadcrumb: 'Producten',
  products_banner_title: 'Productcentrum',
  products_banner_desc: 'Premium natuurlijke materialen, met zorg vervaardigd — elke krabpaal gemaakt om katten van hun krabtueel te laten houden',

  // Products CTA
  products_cta_title: 'Kunt U het Juiste Product Niet Vinden?',
  products_cta_desc: 'Neem contact met ons op voor oplossingen op maat voor uw specifieke behoeften',
  products_cta_btn: 'Neem Contact Op',

  // Product Filter
  filter_all: 'Alle',
  filter_count: '',
  filter_count2: 'producten gevonden',
  sort_default: 'Standaard',
  sort_price_asc: 'Prijs: Laag naar Hoog',
  sort_price_desc: 'Prijs: Hoog naar Laag',
  category_corrugated: 'Golfkarton',
  category_sisal: 'Sisal',
  category_combo: 'Combo',

  // Product Card
  product_view_detail: 'Details Bekijken',

  // Product Detail
  detail_product_code: 'Productcode',
  detail_not_found: 'Product niet gevonden',
  detail_back_to_products: 'Terug naar Producten',

  // Tags
  tag_hot_selling: 'Populair',
  tag_new: 'Nieuw',
  tag_corrugated_paper: 'Golfkarton',
  tag_limited_offer: 'Beperkte Aanbieding',
  tag_bestseller: 'Bestseller',
  tag_recommended: 'Aanbevolen',
  tag_catnip: 'Kattenkruid',
  tag_sisal: 'Sisal',
  tag_corner_protector: 'Hoekbeschermer',
  tag_cat_tree: 'Kattenboom',
  tag_eco_friendly: 'Milieuvriendelijk',

  // Highlight Titles
  highlight_title_triple_layer: 'Drielaags Persproces',
  highlight_title_catnip_infused: 'Biologisch Kattenkruid Geïnfuseerd',
  highlight_title_eco_certified: 'Niet-Giftig Eco Gecertificeerd',
  highlight_title_anti_slip: 'Antislip Bodem',
  highlight_title_natural_sisal: 'Natuurlijk Sisal',
  highlight_title_solid_wood: 'Massief Houten Basis',
  highlight_title_golden_height: 'Optimale 60cm Hoogte',
  highlight_title_nail_care: 'Natuurlijke Nagelverzorging',
  highlight_title_double_sided: 'Dubbelzijdig Bruikbaar',
  highlight_title_wave_curve: 'Golvend Gebogen Ontwerp',
  highlight_title_low_dust: 'Stofarme Formule',
  highlight_title_rubber_strip: 'Antislip Rubberstrip',
  highlight_title_sofa_design: 'Ontworpen voor Banken',
  highlight_title_tool_free: 'Geen Gereedschap Nodig',
  highlight_title_sofa_safe: 'Beschadigt de Bank Niet',
  highlight_title_set_of_4: 'Set van 4',
  highlight_title_catnip_builtin: 'Ingebouwd Kattenkruid',
  highlight_title_round_design: 'Mooi Rond Ontwerp',
  highlight_title_safe_edge: 'Veilige Randafwerking',
  highlight_title_hot_seller: 'Bestseller',
  highlight_title_three_level: 'Drielaags Platform',
  highlight_title_15kg_capacity: 'Draagkracht 15kg+',
  highlight_title_hanging_toy: 'Hangend Speelgoed',
  highlight_title_wide_base: 'Brede Stabiele Basis',

  // Highlight Descriptions
  highlight_desc_triple_layer: '2x zo dicht als gewone producten, duurzamer',
  highlight_desc_catnip_infused: 'Langdurige geur, katten komen vanzelf',
  highlight_desc_eco_certified: 'Veilig zelfs bij kauwen',
  highlight_desc_anti_slip: 'Blijft stevig op zijn plek tijdens gebruik',
  highlight_desc_natural_sisal: 'Handgewikkeld, gelijkmatig en sterk',
  highlight_desc_solid_wood: 'Behandeld grenen, stabiel en valt niet om',
  highlight_desc_golden_height: 'Voldoet aan de strekbehoefte van katten',
  highlight_desc_nail_care: 'Trimt nagels effectief, beschermt meubels',
  highlight_desc_double_sided: 'Omkeerbaar voor dubbele levensduur',
  highlight_desc_wave_curve: 'Past bij de natuurlijke krabhouding van katten',
  highlight_desc_low_dust: 'Weinig vuil, houdt het huis schoon',
  highlight_desc_sofa_design: 'Past perfect op bankhoeken, volledige bescherming',
  highlight_desc_tool_free: 'Sterk klittenband, klaar in 30 seconden',
  highlight_desc_sofa_safe: 'Beschermlaag aan achterkant, laat geen sporen na',
  highlight_desc_set_of_4: 'Beschermt alle vier de bankhoeken tegelijk',
  highlight_desc_catnip_builtin: 'Lost het probleem op dat katten de krabpaal negeren',
  highlight_desc_round_design: 'Plat of aan de muur, twee in één',
  highlight_desc_safe_edge: 'Geen bramen, veilig voor katten',
  highlight_desc_hot_seller: '5000+ per maand verkocht, hoog gewaardeerd',
  highlight_desc_three_level: 'Voldoet aan de liefde van katten voor hoogtes',
  highlight_desc_15kg_capacity: 'Geschikt voor huishoudens met meerdere katten',
  highlight_desc_hanging_toy: 'Stimuleert de speelinteresse van katten',
  highlight_desc_wide_base: 'Valt niet om, zelfs niet bij springen',

  // Additional Tags
  tag_double_sided: 'Dubbelzijdig',
  tag_sofa_protector: 'Bankbeschermer',
  tag_multi_function: 'Multifunctioneel',

  detail_tab_desc: 'Beschrijving',
  detail_tab_specs: 'Specificaties',
  detail_tab_faq: 'FAQ',
  detail_spec_material: 'Materiaal',
  detail_spec_size: 'Afmeting',
  detail_spec_weight: 'Gewicht',
  detail_spec_moq: 'MOQ',
  detail_spec_suitable: 'Geschikt Voor',
  detail_spec_suitable_val: 'Alle maten',
  detail_spec_package: 'Pakketinhoud',
  detail_spec_package_val: 'Product × 1, Handleiding × 1',

  detail_save: 'Bespaar ',
  detail_save_unit: '',
  detail_btn_consult: 'Informeer om te Kopen',
  related_title: 'Misschien Vindt U Dit Ook Leuk',
  related_view_all: 'Alles Bekijken',

  // Contact Banner
  contact_breadcrumb_home: 'Home',
  contact_breadcrumb: 'Contact',
  contact_banner_title: 'Neem Contact Op',
  contact_banner_desc: 'Of het nu gaat om productinformatie, zakelijke samenwerking of after-sales service, we staan altijd klaar om u te helpen',

  // Contact Form
  contact_form_label: 'Bericht Sturen',
  contact_form_title: 'Laat Ons een Bericht',
  contact_form_desc: 'Vul het onderstaande formulier in en we reageren binnen 1 werkdag',
  contact_form_success_title: 'Bericht Verzonden!',
  contact_form_success_desc: 'Bedankt voor uw bericht. We nemen binnen 1 werkdag contact met u op.',
  contact_form_success_btn: 'Nog een Bericht Sturen',
  contact_form_name: 'Uw Naam',
  contact_form_name_placeholder: 'Voer uw naam in',
  contact_form_phone: 'Telefoonnummer',
  contact_form_phone_placeholder: 'Voer uw telefoonnummer in',
  contact_form_email: 'E-mailadres',
  contact_form_email_placeholder: 'Voer uw e-mailadres in',
  contact_form_inquiry: 'Type Aanvraag',
  contact_form_company: 'Bedrijfsnaam',
  contact_form_company_optional: '(Optioneel)',
  contact_form_company_placeholder: 'Voer bedrijfsnaam in indien van toepassing',
  contact_form_message: 'Bericht',
  contact_form_message_placeholder: 'Beschrijf uw behoeften of vragen in detail...',
  contact_form_required: '*',
  contact_form_error: 'Verzenden mislukt. Probeer het opnieuw.',
  contact_form_sending: 'Verzenden...',
  contact_form_submit: 'Bericht Verzenden',
  inquiry_type1: 'Productinformatie',
  inquiry_type2: 'Groothandel Samenwerking',
  inquiry_type3: 'After-Sales Service',
  inquiry_type4: 'Media Samenwerking',
  inquiry_type5: 'Overig',

  // Contact CTA
  contact_cta_title: 'Heeft U Nog Vragen?',
  contact_cta_desc: 'Bekijk onze FAQ, of stuur een e-mail naar',
  contact_cta_btn_browse: 'Producten Bekijken',
  contact_cta_btn_email: 'E-mail Sturen',

  // Contact Info
  contact_info1_title: 'Bedrijfsadres',
  contact_info1_line1: 'FLAT /RM A 9/F SILVERCORP',
  contact_info1_line2: 'INTERNATIONAL TOWER 707-713 NATHAN ROAD MONGKOK HONGKONG',
  contact_info1_action: 'Kaart Bekijken',
  contact_info2_title: 'Klantenservice',
  contact_info2_line1: 'Klantenservice',
  contact_info2_line2: 'Ma–Vr 9:00 – 18:00',
  contact_info2_action: 'Chat Nu',
  contact_info3_title: 'E-mail',
  contact_info3_line1: 'cs@koorpet.com',
  contact_info3_line2: 'Zakelijk: cs@koorpet.com',
  contact_info3_action: 'E-mail Sturen',
  contact_info4_title: 'WhatsApp',
  contact_info4_line1: 'Koorpet Officieel',
  contact_info4_line2: 'Chat direct met ons op WhatsApp',
  contact_info4_action: 'Start Chat',

  // Footer
  footer_brand_desc: 'Gewijd aan R&D en productie van krabpalen, elk kat zijn eigen gelukkig territorium gevend.',
  footer_nav_title: 'Snelle Links',
  footer_products_title: 'Productlijnen',
  footer_product1: 'Golfkarton Krabpalen',
  footer_product2: 'Sisal Krabpalen',
  footer_product3: 'Kattenboom Serie',
  footer_product4: 'Hoekbeschermers',
  footer_product5: 'Kattenkruid Serie',
  footer_contact_title: 'Neem Contact Op',
  footer_address: 'FLAT /RM A 9/F SILVERCORP INTERNATIONAL TOWER 707-713 NATHAN ROAD MONGKOK HONGKONG',
  footer_phone: 'Ma–Vr 9:00 – 18:00',
  footer_whatsapp: 'WhatsApp',
  footer_email: 'cs@koorpet.com',
  footer_hours: 'Ma–Vr 9:00 – 18:00',
  footer_copyright: '© 2026 DANA INTERNATIONAL (HK) CO., LIMITED',
  footer_privacy: 'Privacybeleid',
  footer_terms: 'Gebruiksvoorwaarden',
  footer_admin: 'Beheer',

  // Legal Page
  legal_breadcrumb: 'Juridisch',
  legal_banner_title: 'Juridische Informatie',
  legal_banner_desc: 'Lees de volgende voorwaarden zorgvuldig door om te begrijpen hoe wij uw rechten beschermen',
  legal_updated: 'Laatst bijgewerkt',

  // Privacy Policy
  privacy_s1_title: 'Over Dit Beleid',
  privacy_s1_p1: 'DANA INTERNATIONAL (HK) CO., LIMITED (hierna "Koorpet" of "wij") hecht veel waarde aan de privacy van gebruikers. Dit Privacybeleid legt uit hoe wij uw persoonlijke informatie verzamelen, gebruiken, opslaan en beschermen.',
  privacy_s1_p2: 'Door gebruik te maken van onze website, producten of diensten, stemt u in met de voorwaarden van dit Privacybeleid. Als u niet akkoord gaat, stop dan met het gebruik van onze diensten.',
  privacy_s2_title: 'Informatie Die Wij Verzamelen',
  privacy_s2_p1: 'Om betere diensten te bieden, kunnen wij de volgende soorten informatie verzamelen:',
  privacy_s2_li1: 'Identiteitsinformatie: naam, telefoonnummer, e-mailadres',
  privacy_s2_li2: 'Transactie-informatie: bestelgeschiedenis, verzendadres, betalingsgegevens',
  privacy_s2_li3: 'Apparaatinformatie: IP-adres, browsertype, besturingssysteem',
  privacy_s2_li4: 'Gebruiksgegevens: paginabezoekrecords, klikgedrag, zoekwoorden',
  privacy_s3_title: 'Hoe Wij Uw Informatie Gebruiken',
  privacy_s3_p1: 'De informatie die wij verzamelen wordt gebruikt voor de volgende doeleinden:',
  privacy_s3_li1: 'Verwerking van uw bestellingen en het verlenen van gerelateerde after-sales diensten',
  privacy_s3_li2: 'U productupdates en promotionele meldingen sturen (u kunt zich op elk moment afmelden)',
  privacy_s3_li3: 'Verbetering van onze websitefunctionaliteit en gebruikerservaring',
  privacy_s4_title: 'Informatie Delen en Openbaarmaking',
  privacy_s4_p1: 'Wij verkopen uw persoonlijke informatie niet aan derden. Wij kunnen uw informatie in de volgende omstandigheden delen:',
  privacy_s4_p2: 'Bezorginformatie delen met logistieke partners; voldoen aan wettelijke vereisten; met uw uitdrukkelijke toestemming.',
  privacy_s5_title: 'Informatiebeveiliging',
  privacy_s5_p1: 'Wij gebruiken industriestandaard beveiligingsmaatregelen om uw persoonlijke informatie te beschermen, waaronder SSL-versleutelde overdracht en toegangscontroles voor gegevens. Houd er rekening mee dat internettransmissie niet absoluut veilig is en wij kunnen de absolute veiligheid van informatieoverdracht niet garanderen.',
  privacy_s6_title: 'Uw Rechten',
  privacy_s6_p1: 'U heeft de volgende rechten met betrekking tot uw persoonlijke informatie:',
  privacy_s6_li1: 'Recht op inzage: U kunt op elk moment uw persoonlijke informatie inzien die wij bewaren',
  privacy_s6_li2: 'Recht op correctie: Als informatie onjuist is, kunt u ons verzoeken dit te corrigeren',
  privacy_s6_li3: 'Recht op verwijdering: In bepaalde omstandigheden kunt u ons verzoeken uw persoonlijke informatie te verwijderen',
  privacy_s7_title: 'Neem Contact Op',
  privacy_s7_p1: 'Als u vragen heeft over dit Privacybeleid, neem dan contact met ons op via:',

  // Terms of Use
  terms_s1_title: 'Acceptatie van Voorwaarden',
  terms_s1_p1: 'Welkom op de officiële website van Koorpet. Door deze website te bezoeken of te gebruiken, stemt u ermee in gebonden te zijn aan deze Gebruiksvoorwaarden.',
  terms_s1_p2: 'Wij behouden ons het recht deze voorwaarden op elk moment te wijzigen. Gewijzigde voorwaarden worden op de website gepubliceerd en voortgezet gebruik van de website geldt als acceptatie van de gewijzigde voorwaarden.',
  terms_s2_title: 'Producten en Aankopen',
  terms_s2_p1: 'Bij het kopen van producten via deze website moet u zich houden aan het volgende:',
  terms_s2_li1: 'Alle informatie die u verstrekt moet waar, nauwkeurig en volledig zijn',
  terms_s2_li2: 'U moet minimaal 18 jaar oud zijn of de dienst gebruiken met toestemming van een voogd',
  terms_s2_li3: 'Productprijzen kunnen op elk moment veranderen; de prijs die wordt weergegeven op het moment van bestelling is van toepassing',
  terms_s3_title: 'Verzending en Levering',
  terms_s3_p1: 'Wij zullen alles in het werk stellen om producten binnen de beloofde termijn te leveren, maar de werkelijke levertijden kunnen variëren door logistieke omstandigheden.',
  terms_s3_p2: 'Bezorgbereik, verzendkosten en geschatte aankomsttijden zijn onderhevig aan wat wordt weergegeven op de afrekenpagina. Bij vertragingen door overmacht zullen wij u tijdig informeren.',
  terms_s4_title: 'Retour- en Ruilbeleid',
  terms_s4_p1: 'Wij zijn toegewijd aan het bieden van uitstekende after-sales service. Ons retour- en ruilbeleid is als volgt:',
  terms_s4_li1: 'Binnen 7 dagen na ontvangst van het product, als er een kwaliteitsprobleem is, kunt u een retour of ruil aanvragen',
  terms_s4_li2: 'Producten moeten in originele verpakking zijn, ongebruikt en onbeschadigd',
  terms_s4_li3: 'Retourverzendkosten worden gedragen door de verantwoordelijke partij; bij een kwaliteitsprobleem dragen wij de verzendkosten',
  terms_s5_title: 'Intellectueel Eigendom',
  terms_s5_p1: 'Alle inhoud op deze website, inclusief maar niet beperkt tot tekst, afbeeldingen, logo\'s en productontwerpen, is beschermd door intellectuele eigendomswetten en behoort toe aan Koorpet.',
  terms_s5_p2: 'Zonder onze schriftelijke toestemming mag u geen inhoud van deze website kopiëren, wijzigen, distribueren of op enige andere manier gebruiken.',
  terms_s6_title: 'Disclaimer',
  terms_s6_p1: 'De inhoud van deze website is uitsluitend ter referentie. Wij zijn niet verantwoordelijk voor directe of indirecte verliezen die voortvloeien uit het gebruik van deze website of het vertrouwen op de informatie ervan. Productafbeeldingen zijn uitsluitend ter referentie; het werkelijk ontvangen product is bepalend.',
  terms_s7_title: 'Toepasselijk Recht',
  terms_s7_p1: 'Deze Gebruiksvoorwaarden worden beheerst door de wetten van de Volksrepubliek China. Bij geschillen zullen beide partijen eerst proberen deze via onderhandeling op te lossen; als onderhandeling mislukt, wordt het geschil voorgelegd aan de bevoegde rechtbank in Hong Kong SAR.',
  terms_s8_title: 'Neem Contact Op',
  terms_s8_p1: 'Als u vragen heeft over deze Gebruiksvoorwaarden, neem dan contact met ons op via:',
};

export default nl;